<template>
  <div class="toolbar">
    <div class="btn-group">
      <slot></slot>
      <a-button
        v-for="(item, index) of toolBarList"
        :key="index"
        @click="item.handle(item)"
        :type="item.type"
        :disabled="item.authDisabled"
        :loading="item.loading && btnLoading.loading"
      >
        {{item.text}}
      </a-button>
    </div>
  </div>
</template>

<script>
import mixin from '../js/mixins';
export default {
  mixins: [mixin.toolBarAuth],
  name: 'toolbar',
  props: {
    toolBarList: {
      type: Array,
      default: () => []
    },
    btnLoading: ''
  },
  data () {
    return {};
  }
};
</script>



// WEBPACK FOOTER //
// src/package/toolbar.vue